export interface ApiConfig {
    apiBaseURL: string;
    timeServiceBaseURL: string;
}

/**
 * Default fallback URLs per NODE_ENV.
 * Override any of these per-client via environment variables:
 *   REACT_APP_API_URL          → main API base URL (e.g. https://api.myclient.com)
 *   REACT_APP_TIME_SERVICE_URL → time-service base URL
 *
 * Set those variables in a .env file, in CI/CD, or in docker-compose
 * without touching this file.
 */
const FALLBACK_API: Record<string, string> = {
    development:"http://localhost:8000",
    production: "https://api-lite.cactusds.com",
    test:       "https://api-lite.cactusds.com:88",
};

const FALLBACK_TIME_SERVICE: Record<string, string> = {
    development:"http://localhost:3400",
    production: "https://time-service.cactusds.com",
    test:       "https://time-service.cactusds.com",
};

export function getApiConfig(): ApiConfig {
    const env = process.env.NODE_ENV ?? "development";

    return {
        apiBaseURL:        process.env.REACT_APP_API_URL          ?? FALLBACK_API[env]          ?? FALLBACK_API.development,
        timeServiceBaseURL:process.env.REACT_APP_TIME_SERVICE_URL ?? FALLBACK_TIME_SERVICE[env] ?? FALLBACK_TIME_SERVICE.development,
    };
}
